const dateFormats = new Map<string, Intl.DateTimeFormat>();
const numberFormats = new Map<string, Intl.NumberFormat>();

const CLOCK: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: 'UTC' };
const DATE_TIME: Intl.DateTimeFormatOptions = { ...CLOCK, day: '2-digit', month: 'short', year: 'numeric' };

function dateFormat(kind: 'clock' | 'dateTime', locale: string): Intl.DateTimeFormat {
  const key = `${kind}|${locale}`;
  const existing = dateFormats.get(key);
  if (existing) return existing;
  const format = new Intl.DateTimeFormat(locale, kind === 'clock' ? CLOCK : DATE_TIME);
  dateFormats.set(key, format);
  return format;
}

function numberFormat(locale: string, fractionDigits: number, signed: boolean): Intl.NumberFormat {
  const key = `${locale}|${fractionDigits}|${signed}`;
  const existing = numberFormats.get(key);
  if (existing) return existing;
  const format = new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    signDisplay: signed ? 'exceptZero' : 'auto',
  });
  numberFormats.set(key, format);
  return format;
}

/** Results times are shown in UTC. */
export function formatClock(ms: number, locale: string): string {
  return dateFormat('clock', locale).format(ms);
}

export function formatDateTime(ms: number, locale: string): string {
  return dateFormat('dateTime', locale).format(ms);
}

export function formatNumber(value: number, locale: string, fractionDigits = 0): string {
  return numberFormat(locale, fractionDigits, false).format(value);
}

export function formatSignedNumber(value: number, locale: string, fractionDigits = 0): string {
  return numberFormat(locale, fractionDigits, true).format(value);
}
